import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ModulosComponent } from './main/modulos/modulos.component';
import { PerfilUsuarioComponent } from './main/modulos/perfil-usuario/perfil-usuario.component';
import { MasterComponent } from './master.component';
import { AuthenticationGuard } from './authentication/authentication.guard';

const routes: Routes = [
  { path: '', loadChildren: () => import('./authentication/authentication.module').then(m => m.AuthenticationModule) },
  { path: 'public', loadChildren: () => import('./modules/public/public.module').then(m => m.PublicModule) },
  { path: 'sispac/public', loadChildren: () => import('./modules/public/public.module').then(m => m.PublicModule) },
  { path: 'chatbot', loadChildren: () => import('./modules/chatbot/chatbot.module').then(m => m.ChatbotModule)},
  { path: 'modulos', component: ModulosComponent, loadChildren: () => import('./main/main.module').then(m => m.MainModule) },
  { path: 'perfil', component: PerfilUsuarioComponent },
  { path: 'main', component: MasterComponent, loadChildren: () => import('./master.module').then(m => m.MasterModule), canActivate: [AuthenticationGuard] },
  { path: 'manual', loadChildren: () => import('./modules/manual/manual.module').then(m => m.ManualModule) },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
